var map = {
	"./assetx.json": 2947,
	"./automata.json": 6137,
	"./benchmatrix.json": 6690,
	"./bioportal.json": 3097,
	"./blocksettle.json": 4439,
	"./branchfuture.json": 9768,
	"./branchtransform.json": 3693,
	"./cardmaster.json": 8119,
	"./chainlend.json": 9305,
	"./chainpay.json": 3014,
	"./chatbank.json": 7947,
	"./collateralx.json": 6774,
	"./competwatch.json": 4776,
	"./compliancewatch.json": 4703,
	"./corporateflow.json": 5222,
	"./creditflow.json": 7990,
	"./cryptovault.json": 5614,
	"./databridge.json": 6778,
	"./datacore.json": 692,
	"./dataquality.json": 8916,
	"./dltrade.json": 9755,
	"./factorplus.json": 4008,
	"./fatcaplus.json": 3354,
	"./fraudshield.json": 8978,
	"./fundmatrix.json": 9237,
	"./greenmetrics.json": 1403,
	"./identrack.json": 832,
	"./instantbanking.json": 4938,
	"./korepay.json": 4558,
	"./leasingtech.json": 4356,
	"./limitcontrol.json": 3367,
	"./liquidityai.json": 4099,
	"./loanbot.json": 7562,
	"./loanscape.json": 2537,
	"./marketintel.json": 1769,
	"./marketpulse.json": 3700,
	"./messagingpro.json": 6740,
	"./microfinx.json": 506,
	"./mifidwatch.json": 7111,
	"./modelrisk.json": 5607,
	"./mxpay.json": 4420,
	"./neocore.json": 2628,
	"./novakyc.json": 2218,
	"./onboardflow.json": 7258,
	"./paylearning.json": 4929,
	"./pensiontech.json": 100,
	"./pentest360.json": 5673,
	"./powerbudget.json": 2045,
	"./quantumopen.json": 4359,
	"./recoverplus.json": 4665,
	"./regrisk.json": 3476,
	"./regtechplus.json": 9575,
	"./remittech.json": 2988,
	"./riskmatrix.json": 77,
	"./smartbranch.json": 8688,
	"./smartcrm.json": 5860,
	"./smartdoc.json": 6266,
	"./supplybank.json": 1398,
	"./sustainbank.json": 8526,
	"./tradefinanceplus.json": 2091,
	"./treasuryplus.json": 3518,
	"./vipbanking.json": 2364,
	"./wealthmap.json": 9568,
	"./wealthsphere.json": 1379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7854;